<template>
  <body class="ui_index modal-open">
  <div class="overlay"></div>
  <div class="modal_fixed">
    <div class="new_achievement_box modal_cont" id="wheel_prize_modal">
        <img :src="closeIconSrc" class="btn_close" @click="goTOGetStarted">
        <p>{{ getTranslations.visitor_free_trial_modals_this_answer }} <br>
          {{ getTranslations.visitor_free_trial_modals_start_daily }} <br><br>
          {{ getTranslations.visitor_free_trial_modals_won_fisrt }} <span>[ {{ freeTrialPoints[0] }} ]</span>
          {{ getTranslations.visitor_free_trial_modals_points }}<br>
          {{ getTranslations.visitor_free_trial_modals_points_count }}
        </p>
        <img src="/static/images/achievements/prize-spin.svg" class="prize_spin_img">
        <button type="" class="claim_prize" @click="goToRegistration">
          {{ getTranslations.visitor_free_trial_modals_claim_points }}
        </button>
      </div>
  </div>
  </body>
</template>

<script>
//
import { mapGetters, mapState, mapMutations } from 'vuex';
import SkinMixin from '@/common/mixins/skin';

export default {
  name: 'WrongAnswer',
  mixins: [SkinMixin],
  computed: {
    closeIconSrc() {
      return this.$_skinImage({ fileName: 'store/icon-close-back-popup.svg', skins: [100] });
    },
    ...mapState('common', [
      'freeTrialRedirectionUrl',
      'freeTrialPoints',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('common', [
      'getRefUrl',
      'getClickId',
      'getCampaignId',
      'getPublisherId',
    ]),
  },
  methods: {
    ...mapMutations('game', [
      'storeRegistrationPoints',
    ]),
    ...mapMutations('common', [
      'setFreeTrialUserPrice',
    ]),
    saveFreePoints() {
      this.setFreeTrialUserPrice(this.freeTrialPoints[0]);
      return this.freeTrialPoints[0];
    },
    goTOGetStarted() {
      this.$router.push('/');
    },
    goToRegistration() {
      if (this.getRefUrl === undefined && this.getClickId === undefined && this.publisherId === undefined && this.campaignId === undefined) this.$router.push(`${this.freeTrialRedirectionUrl}?totalPoints=${this.saveFreePoints()}`);
      else this.$router.push(`${this.freeTrialRedirectionUrl}?refUrl=${this.getRefUrl || ''}&clickId=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.campaignId || ''}&totalPoints=${this.saveFreePoints()}`);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeTrial/modals/WrongAnswer.vue